import { Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { StatementView } from '@/api/generated';
import { MoneyCell, NumericCell } from '@/components/cells';
import { StatusChip } from '@/components/status/StatusChip';
import { useCivilRange } from '@/i18n/useCivilRange';

export interface StatementsTableProps {
  statements: StatementView[];
}

export function StatementsTable({ statements }: StatementsTableProps) {
  const { t } = useTranslation();
  const civilRange = useCivilRange(t('subscribers.unavailable'));
  const rows = [...statements].sort((a, b) =>
    b.periodEnd.localeCompare(a.periodEnd),
  );

  return (
    <Paper sx={{ overflow: 'hidden' }}>
      <Table size="small" aria-label={t('pages.statements.title')}>
        <TableHead>
          <TableRow>
            <TableCell>{t('subscribers.stmt.period')}</TableCell>
            <TableCell align="right">{t('subscribers.stmt.seats')}</TableCell>
            <TableCell align="right">{t('subscribers.stmt.tax')}</TableCell>
            <TableCell align="right">{t('subscribers.stmt.total')}</TableCell>
            <TableCell>{t('subscribers.stmt.status')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => {
            const currency = row.currency;
            return (
              <TableRow key={row.id}>
                <TableCell component="th" scope="row">
                  {civilRange(row.periodStart, row.periodEnd)}
                </TableCell>
                <NumericCell value={row.seats} />
                <MoneyCell minor={row.taxMinor} currency={currency} />
                <MoneyCell minor={row.totalMinor} currency={currency} />
                <TableCell>
                  <StatusChip domain="statement" status={row.chargeStatus} />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Paper>
  );
}
